import axios from '../utils/axios';

export default function activateSeekerPlan(adminId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/subscription/admin/activate-subscription?type=regular`, body);
};